const toNum = (v) => {
    const n = parseFloat(v);
    return isNaN(n) ? 0 : n;
};

export const FareCalculator = (distance,time,rateDetails,instructionData, decimal)=>{

    const dec = parseInt(decimal) >= 0 ? parseInt(decimal) : 2;

    let baseCalculated =  (toNum(rateDetails.rate_per_unit_distance) * toNum(distance)) + (toNum(rateDetails.rate_per_hour) * (toNum(time) / 3600));
    if(toNum(rateDetails.base_fare)>0){
        baseCalculated = baseCalculated + toNum(rateDetails.base_fare);
    }
    if(instructionData && instructionData.parcelTypeSelected){
        baseCalculated = baseCalculated + toNum(instructionData.parcelTypeSelected.amount);
    }
    if(instructionData && instructionData.optionSelected){
        baseCalculated = baseCalculated + toNum(instructionData.optionSelected.amount);
    }
    const minFare = toNum(rateDetails.min_fare);
    let total = baseCalculated > minFare ? baseCalculated : minFare;
    let convenienceFee = 0;
    if(rateDetails.convenience_fee_type && rateDetails.convenience_fee_type == 'flat'){
        convenienceFee = toNum(rateDetails.convenience_fees);
    }else{
        convenienceFee = (total*toNum(rateDetails.convenience_fees)/100);
    }
    let grand = total + convenienceFee;

    return {
        totalCost:parseFloat(total.toFixed(dec)),
        grandTotal:parseFloat(grand.toFixed(dec)),
        convenience_fees:parseFloat(convenienceFee.toFixed(dec))
    }

}